import {
  ADD_TEACHER_REQUEST,
  ADD_TEACHER_SUCCESS,
  ADD_TEACHER_FAIL,
  GET_TEACHERS_REQUEST,
  GET_TEACHERS_SUCCESS,
  GET_TEACHERS_FAIL,
  UPDATE_TEACHER_REQUEST,
  UPDATE_TEACHER_SUCCESS,
  UPDATE_TEACHER_FAIL,
  DELETE_TEACHER_REQUEST,
  DELETE_TEACHER_SUCCESS,
  DELETE_TEACHER_FAIL,
  CLEAR_ERRORS,
} from "../../constants/admin/teachersConstants";

const initialState = {
  teachers: [],
  loading: false,
  error: null,
};

export const teacherReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_TEACHER_REQUEST:
    case GET_TEACHERS_REQUEST:
    case UPDATE_TEACHER_REQUEST:
    case DELETE_TEACHER_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case ADD_TEACHER_SUCCESS:
      return {
        ...state,
        loading: false,
        teachers: [...state.teachers, action.payload.teacher],
      };

    case GET_TEACHERS_SUCCESS:
      return {
        ...state,
        loading: false,
        teachers: action.payload.teachers,
      };

    case UPDATE_TEACHER_SUCCESS:
      return {
        ...state,
        loading: false,
        teachers: state.teachers.map((teacher) =>
          teacher._id === action.payload._id ? action.payload : teacher
        ),
      };

    case DELETE_TEACHER_SUCCESS:
      return {
        ...state,
        loading: false,
        teachers: state.teachers.filter(
          (teacher) => teacher._id !== action.payload.id
        ),
      };

    case ADD_TEACHER_FAIL:
    case GET_TEACHERS_FAIL:
    case UPDATE_TEACHER_FAIL:
    case DELETE_TEACHER_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };

    default:
      return state;
  }
};
